'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
var paper = require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');

var TopContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 16px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 16px;\n"])));
var Title = styled__default.p(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: 500 14px/22px ", ";\n  color: ", ";\n  margin: 0 0 4px;\n"], ["\n  font: 500 14px/22px ", ";\n  color: ", ";\n  margin: 0 0 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var TitleNote = styled__default.span(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: italic 14px/22px ", ";\n"], ["\n  font: italic 14px/22px ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var SubTitle = styled__default.p(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 14px/22px ", ";\n  color: ", ";\n  margin: 0;\n"], ["\n  font: 14px/22px ", ";\n  color: ", ";\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var StyledPaper = styled__default(paper.Paper)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  padding: 24px;\n"], ["\n  padding: 24px;\n"])));
var FormGroup = function (_a) {
    var dataCy = _a.dataCy, dataTestId = _a.dataTestId, title = _a.title, subTitle = _a.subTitle, children = _a.children, _b = _a.optional, optional = _b === void 0 ? false : _b, actions = _a.actions, className = _a.className, rest = tslib_es6.__rest(_a, ["dataCy", "dataTestId", "title", "subTitle", "children", "optional", "actions", "className"]);
    return (React__default.createElement("div", tslib_es6.__assign({ "data-cy": dataCy, "data-testid": dataTestId }, rest, { className: className }),
        (title || subTitle || actions) && (React__default.createElement(TopContainer, { className: className + "-top-container" },
            React__default.createElement("div", null,
                title && (React__default.createElement(Title, { className: className + "-title" },
                    title,
                    optional && React__default.createElement(TitleNote, null, " (optional)"))),
                subTitle && React__default.createElement(SubTitle, null, subTitle)),
            actions && React__default.createElement("div", null, actions))),
        children && React__default.createElement(StyledPaper, { className: className + "-paper", depth: 1, borderRadius: "sm" }, children)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.FormGroup = FormGroup;
